import { render, staticRenderFns } from "./BollettinoData.vue?vue&type=template&id=83e6684c"
import script from "./BollettinoData.vue?vue&type=script&lang=js"
export * from "./BollettinoData.vue?vue&type=script&lang=js"
import style0 from "./BollettinoData.vue?vue&type=style&index=0&id=83e6684c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports